var React = require('react');

function Funding (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 13L25 0.5L50 13V18H0V13ZM12.5 23H5V40.5H12.5V23ZM28.75 40.5V23H21.25V40.5H28.75ZM0 53V45.5H50V53H0ZM45 23H37.5V40.5H45V23Z","fill":"#00933F"}));
}

Funding.defaultProps = {"width":"50","height":"53","viewBox":"0 0 50 53","fill":"none"};

module.exports = Funding;

Funding.default = Funding;
